import { render, staticRenderFns } from "./DoctorCertificate.vue?vue&type=template&id=2f2a7c88&"
import script from "./DoctorCertificate.vue?vue&type=script&lang=js&"
export * from "./DoctorCertificate.vue?vue&type=script&lang=js&"
import style0 from "./DoctorCertificate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports